import { Icon, IconName } from '@openeducation/oe-rn-components';
import React from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  TouchableOpacityProps,
} from 'react-native';

import { useColors } from '../../../hooks';

interface FeedbackIconButtonProps extends TouchableOpacityProps {
  iconName: IconName;
  iconSize: number;
}

const FeedbackIconButton: React.FC<FeedbackIconButtonProps> = ({
  iconName,
  iconSize,
  style,
  ...props
}) => {
  const colors = useColors();

  return (
    <TouchableOpacity style={[styles.container, style]} {...props}>
      <Icon size={iconSize} name={iconName} color={colors.gray} type="solid" />
    </TouchableOpacity>
  );
};

export default FeedbackIconButton;

const styles = StyleSheet.create({
  container: {
    padding: 8,
  },
});
